<template>
  <customer-layout>
    <div v-if="client.iprofile_token != null">
      <div class="w-full text-xl font-sans font-medium relative">
        <div v-if="nojob" class="text-xl text-black px-8">{{ nojob}}</div>
        <div v-else class="min-h-screen flex flex-col justify-items-center justify-between">
          <div class="max-w-screen-md mx-auto pt-6 pb-32 px-4">
            <h2 class="text-2xl font-black text-black mb-2">{{ $t('Which job are you best suited for?') }}</h2>
            <p class="font-extralight text-black">{{ $t('Although you are endowed with many positive qualities, from our point of view') }} <span class="font-black text-purple-900 underline">{{ $t('you could excel in') }} {{ job }}.</span></p>
            <p class="font-extralight text-black mt-2">{{ $t('Knowing your areas of excellence is JUST ONE of the necessary steps to build a highly successful career. It is also important that you associate with people who are very capable in the activity in which you would like to establish yourself and build a training program that will help you to bring out your full potential.') }}</p>
            <p class="font-extralight text-black mt-2">{{ $t('In this regard, write below the names of two people, already successful, in the activity in which you would like to try your hand, which you would like to frequent more.') }}</p>

            <form @submit.prevent="submitNames" class="my-4">
              <div class="mb-2">
                <label for="name_one">1</label>
                <input type="text" name="name_one" v-model="name_one" class="border-solid border-gray-400 rounded">
              </div>
              <div>
                <label for="">2</label>
                <input type="text" name="name_two" v-model="name_two" class="border-solid border-gray-400 rounded">
              </div>
              <button type="submit"  class="inline-block w-auto bg-pink-600 text-white rounded-full text-xs font-semibold uppercase px-4 py-1 mt-4">{{ $t('register') }}</button>
            </form>

            <p class="font-extralight text-black mt-2">{{ $t('Some programs in this app will be able to help you develop the activities you need to be successful.') }}</p>
            <p class="font-extralight text-black mt-2">La <a href="https://engageeditore.com/products/iosm-app-accesso-completo" class="underline">App I-OSM</a> {{ $t("however, with all its development paths, it is one of OSM's best professional offerings to help you develop and enhance all your skills.") }}</p>
          </div>
          <!-- <div class="btm-bkg"></div> -->
        </div>
      </div>
    </div>

    <div v-else class="h-screen flex-col  bg-gray-800 flex justify-center items-center  content-center">


        <img src="/img/icon-qrcode.svg" alt="gem" class="w-4/12 my-2" />
        <h4 class="text-white text-center text-xl py-1 px-8">{{ $t('You have not yet uploaded the I-Profile questionnaire') }}</h4>
        <inertia-link :href="route('qrcode.create')" class="bg-pink-600 px-6 py-2 rounded-xl mx-4 my-4 text-white text-center">{{ $t('It begins now') }}</inertia-link>

        <h4 class="text-white text-center py-1 px-8 mt-4">{{ $t("Don't have the I-Profile questionnaire?") }}</h4>
        <a href="https://docs.google.com/forms/d/1tliF3LoW4eCZn0rOZCMxxTcdnqMW8FCSZ8Sr977ymoQ/edit?ts=60c74cbe" target="blank" class="bg-blue-600 px-6 py-2 rounded-xl mx-4 my-4 text-white text-center">{{ $t('Request it') }}</a>
    </div>
   <BottomBar :diamonds="diamonds"/>
  </customer-layout>
</template>

<script>
import BottomBar from "@/Layouts/BottomBar"
import CustomerLayout from '@/Layouts/CustomerLayout.vue'

export default {
  components: {
    BottomBar,
    CustomerLayout
  },
  props: [
    "client",
    "user",
    "survey",
    "mytest",
    "job",
    "nojob",
    'diamonds'
  ],
  data() {
    return {
      name_one: null,
      name_two: null,
      };
  },
  methods: {
    submitNames() {
      const data = new FormData()
      data.append('name_one', this.name_one);
      data.append('name_two', this.name_two);
      this.$inertia.post(this.route('jobs.store'), data, {
        onStart: () => this.sending = true,
        onFinish: () => this.sending = false,
      })
    },
  }
};
</script>


<style>
.osm-bkg {
background: #F40793;
background: -webkit-linear-gradient(top, #F40793, #F4A75D);
background: -moz-linear-gradient(top, #F40793, #F4A75D);
background: linear-gradient(to bottom, #F40793, #F4A75D);
}

.btm-bkg {
  width: 100%;
  height: 100px;
  background-image: url(/img/gem.png);
  background-position: center;
  background-size: cover;
}
</style>